import qs from 'query-string';

const DEFAULT_PAGE = 1;
const HTML_FILE_PATTERN = /\.html$/;

function formatPathForResources(path) {
  if (HTML_FILE_PATTERN.test(path)) {
    return path;
  }

  let finalPath = path.charAt(0) === '/' ? path : `/${path}`;

  return finalPath.charAt(finalPath.length -1) === '/' ? finalPath : `${finalPath}/`;
}

function setUrlParams(params) {
  const { history } = this;

  const urlParams = Object.assign(qs.parse(location.search), params);

  history.push(`?${qs.stringify(urlParams)}${location.hash}`);
}

function retrieveDefaultParams() {
  const urlParams = qs.parse(location.search);

  if(!urlParams.page) {
    urlParams.page = DEFAULT_PAGE;
  }

  if (!urlParams.pageSize) {
    delete urlParams.pageSize;
  }

  return urlParams;
}

export {
  formatPathForResources,
  setUrlParams,
  retrieveDefaultParams
};